const config = {
  withCredentials: true,
  headers: {
    "Content-Type": "application/json",
  },
};

export default config;
